import { render, staticRenderFns } from "./brieHeader.vue?vue&type=template&id=88113638&scoped=true"
import script from "./brieHeader.vue?vue&type=script&lang=js"
export * from "./brieHeader.vue?vue&type=script&lang=js"
import style0 from "./brieHeader.vue?vue&type=style&index=0&id=88113638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88113638",
  null
  
)

export default component.exports